var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.$auth.watch.authenticated
    ? _c(
        "v-menu",
        { attrs: { bottom: "", left: "", "offset-y": "" } },
        [
          _c(
            "v-btn",
            {
              attrs: {
                slot: "activator",
                color: "white",
                flat: "",
                round: "",
                icon: ""
              },
              slot: "activator"
            },
            [_c("v-icon", [_vm._v("more_vert")])],
            1
          ),
          _vm._v(" "),
          _c(
            "v-list",
            [
              _vm._l(_vm.menuItems, function(item) {
                return [
                  _c(
                    "v-list-tile",
                    {
                      key: item.name,
                      on: {
                        click: function($event) {
                          return _vm.$router.push({
                            name: item.name,
                            params: { teamId: _vm.$teamService.currentTeamId }
                          })
                        }
                      }
                    },
                    [_c("v-list-tile-title", [_vm._v(_vm._s(item.title))])],
                    1
                  )
                ]
              })
            ],
            2
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-beffe230", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-beffe230","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainMenu.vue
// module id = n9Os
// module chunks = 1